import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    {...props}
  >
    <path
      fill="url(#remove_bg_a)"
      d="M9.64 7.015c-.194-1.418-.243-1.472-1.74-1.753a.19.19 0 0 1-.12-.058.182.182 0 0 1-.05-.12.173.173 0 0 1 .048-.123.182.182 0 0 1 .121-.057c1.498-.208 1.552-.294 1.742-1.734a.175.175 0 0 1 .057-.117.184.184 0 0 1 .249.002.172.172 0 0 1 .054.12c.18 1.419.26 1.453 1.741 1.729.047.003.09.023.122.057.032.033.05.077.05.122 0 .107-.07.16-.19.181-1.471.234-1.54.326-1.72 1.743a.174.174 0 0 1-.05.127.182.182 0 0 1-.126.055.185.185 0 0 1-.13-.048.176.176 0 0 1-.057-.123v-.003Z"
    />
    <path
      fill="url(#remove_bg_b)"
      d="M17.836 6.056c-.264-1.91-.196-1.91-2.286-2.288a.256.256 0 0 1-.16-.08.244.244 0 0 1-.003-.328.245.245 0 0 1 .163-.077c2.09-.279 2.029-.342 2.286-2.28a.235.235 0 0 1 .074-.168.248.248 0 0 1 .397.083c.012.029.018.06.017.091.241 1.91.275 1.903 2.27 2.274.062.005.12.033.161.078a.236.236 0 0 1 .064.165c0 .144-.096.22-.257.242-1.978.314-1.998.365-2.24 2.273a.237.237 0 0 1-.074.158.249.249 0 0 1-.33.01.237.237 0 0 1-.084-.153h.002Z"
    />
    <path
      fill="url(#remove_bg_c)"
      d="M19.724 14.091c-.2-1.45-.203-1.45-1.741-1.738a.195.195 0 0 1-.123-.06.185.185 0 0 1-.051-.123.178.178 0 0 1 .048-.127.188.188 0 0 1 .126-.058c1.537-.212 1.546-.26 1.741-1.733a.18.18 0 0 1 .055-.128.19.19 0 0 1 .304.058c.01.023.015.046.015.07.184 1.45.207 1.446 1.728 1.727a.192.192 0 0 1 .124.06c.032.034.05.079.05.125 0 .109-.073.163-.195.184-1.509.239-1.523.278-1.706 1.728a.18.18 0 0 1-.051.13.19.19 0 0 1-.306-.051.18.18 0 0 1-.017-.07l-.001.006Z"
    />
    <path
      fill="url(#remove_bg_d)"
      d="M12.535 21.044c-.176-1.276-.166-1.253-1.512-1.506a.17.17 0 0 1-.108-.053.162.162 0 0 1-.044-.11.155.155 0 0 1 .042-.11.163.163 0 0 1 .11-.052c1.347-.186 1.341-.229 1.512-1.525a.156.156 0 0 1 .052-.105.164.164 0 0 1 .111-.042c.042 0 .082.016.112.044.03.029.048.068.049.109.162 1.276.197 1.27 1.53 1.519.04.003.08.022.108.052a.16.16 0 0 1 .043.11c0 .095-.063.144-.17.162-1.324.21-1.35.221-1.511 1.496a.158.158 0 0 1-.096.15.166.166 0 0 1-.216-.08.156.156 0 0 1-.014-.06h.002Z"
    />
    <path
      fill="url(#remove_bg_e)"
      d="M2.972 19.238c.55 0 1.052-.133 1.504-.4a3.02 3.02 0 0 0 1.082-1.081c.27-.455.404-.961.404-1.518 0-.291.03-.506.093-.646.061-.139.2-.267.417-.385l12.379-6.547c-.136-.606-.503-.973-1.1-1.1-.598-.127-1.395-.011-2.392.348l-6.212 2.2c-.458.162-.802.366-1.03.614-.23.247-.41.582-.54 1.003l-.139.529a1.094 1.094 0 0 1-.283.487c-.127.121-.345.262-.655.423l-.928.483a1.11 1.11 0 0 1-.455.12c-.205 0-.381-.041-.53-.125a4.063 4.063 0 0 0-.575-.255c-.236-.087-.582-.13-1.04-.13-.551 0-1.051.133-1.5.4a3.005 3.005 0 0 0-1.073 1.076C.133 15.186 0 15.688 0 16.24c0 .557.133 1.061.4 1.513.266.452.623.813 1.072 1.082.449.27.949.404 1.5.404Zm0-1.328c-.452 0-.84-.162-1.161-.487a1.62 1.62 0 0 1-.483-1.184 1.682 1.682 0 0 1 .817-1.44c.248-.148.523-.223.827-.223.31 0 .59.075.84.223a1.67 1.67 0 0 1 .822 1.44c0 .464-.161.859-.483 1.184a1.597 1.597 0 0 1-1.18.487Zm6.351-5.58a.628.628 0 0 1-.445-.187.604.604 0 0 1-.195-.455c0-.185.065-.34.195-.464a.65.65 0 0 1 .91 0c.13.124.195.279.195.464 0 .18-.065.332-.195.455a.65.65 0 0 1-.465.186Zm-6.351-1.375c.346 0 .625-.025.835-.074.21-.05.386-.109.525-.177a7.67 7.67 0 0 1 .385-.176c.118-.05.251-.075.4-.075.13 0 .281.04.455.121l1.03.539c.08.05.155.093.223.13.068.037.13.074.186.111h.046c.1-.346.23-.631.39-.854.161-.223.375-.415.641-.576v-.046l-1.504-.799c-.266-.142-.437-.285-.51-.427-.075-.142-.112-.368-.112-.678 0-.557-.135-1.063-.404-1.518a3.02 3.02 0 0 0-1.082-1.082 2.909 2.909 0 0 0-1.504-.4c-.551 0-1.051.135-1.5.405-.449.269-.806.63-1.073 1.081C.133 6.912 0 7.417 0 7.974c0 .551.133 1.052.4 1.504.266.452.623.811 1.072 1.078.449.266.949.399 1.5.399Zm0-1.319c-.304 0-.58-.076-.827-.227a1.734 1.734 0 0 1-.594-.604 1.6 1.6 0 0 1-.223-.831c0-.47.16-.867.483-1.189a1.583 1.583 0 0 1 1.16-.482c.465 0 .858.16 1.18.482.322.322.483.719.483 1.189a1.6 1.6 0 0 1-.223.831 1.72 1.72 0 0 1-.599.604c-.25.151-.53.227-.84.227Zm12.387 6.686c1.003.372 1.802.49 2.396.353.594-.136.96-.514 1.096-1.133l-5.785-3.073-3.25 1.708v.093l5.543 2.052Z"
    />
    <defs>
      <linearGradient
        id="remove_bg_a"
        x1={7.187}
        x2={12.252}
        y1={5.315}
        y2={7.277}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF1866" />
        <stop offset={0.162} stopColor="#FD0167" />
        <stop offset={0.375} stopColor="#F00188" />
        <stop offset={0.476} stopColor="#DD01A0" />
        <stop offset={0.609} stopColor="#D203B4" />
        <stop offset={0.778} stopColor="#C10EC4" />
        <stop offset={0.994} stopColor="#99019C" />
      </linearGradient>
      <linearGradient
        id="remove_bg_b"
        x1={14.61}
        x2={21.265}
        y1={3.803}
        y2={6.378}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF1866" />
        <stop offset={0.162} stopColor="#FD0167" />
        <stop offset={0.375} stopColor="#F00188" />
        <stop offset={0.476} stopColor="#DD01A0" />
        <stop offset={0.609} stopColor="#D203B4" />
        <stop offset={0.778} stopColor="#C10EC4" />
        <stop offset={0.994} stopColor="#99019C" />
      </linearGradient>
      <linearGradient
        id="remove_bg_c"
        x1={17.264}
        x2={22.34}
        y1={12.385}
        y2={14.35}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF1866" />
        <stop offset={0.162} stopColor="#FD0167" />
        <stop offset={0.375} stopColor="#F00188" />
        <stop offset={0.476} stopColor="#DD01A0" />
        <stop offset={0.609} stopColor="#D203B4" />
        <stop offset={0.778} stopColor="#C10EC4" />
        <stop offset={0.994} stopColor="#99019C" />
      </linearGradient>
      <linearGradient
        id="remove_bg_d"
        x1={10.394}
        x2={14.833}
        y1={19.559}
        y2={21.284}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF1866" />
        <stop offset={0.162} stopColor="#FD0167" />
        <stop offset={0.375} stopColor="#F00188" />
        <stop offset={0.476} stopColor="#DD01A0" />
        <stop offset={0.609} stopColor="#D203B4" />
        <stop offset={0.778} stopColor="#C10EC4" />
        <stop offset={0.994} stopColor="#99019C" />
      </linearGradient>
      <linearGradient
        id="remove_bg_e"
        x1={-2.451}
        x2={18.352}
        y1={12.849}
        y2={23.494}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF1866" />
        <stop offset={0.162} stopColor="#FD0167" />
        <stop offset={0.375} stopColor="#F00188" />
        <stop offset={0.476} stopColor="#DD01A0" />
        <stop offset={0.609} stopColor="#D203B4" />
        <stop offset={0.778} stopColor="#C10EC4" />
        <stop offset={0.994} stopColor="#99019C" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
